import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    paper: {
      width: 608,
      maxHeight: 436,
    },

    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadius,
      zIndex: theme.zIndex.modal,
      overflow: 'hidden',
      padding: theme.spacing(4, 4, 3, 4),

      '&[data-popper-reference-hidden]': {
        visibility: 'hidden',
      },
    },
    buttonCloseArea: {
      display: 'flex',
      justifyContent: 'flex-end',
      borderTop: `1px solid ${COLORS.gray.gray70}`,
      padding: theme.spacing(2, 4, 2, 2),
    },
    buttonClose: {
      padding: theme.spacing(1.5, 2),
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14),
    },

    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      color: COLORS.neutral.black,
      fontWeight: theme.typography.fontWeightMedium,
    },

    details: {
      marginTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minHeight: 100,
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: 7,
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: theme.spacing(0.5),
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        boxShadow: '0 0 1px rgba(255, 255, 255, 0.5)',
      },
    },

    baseItemRoot: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      marginTop: theme.spacing(1),
    },

    baseItemTitle: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
      color: COLORS.gray.black,
      fontWeight: theme.typography.fontWeightMedium,
    },

    baseItemBody: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
      color: COLORS.gray.black,
      marginBottom: theme.spacing(1),
    },
  }),
  {
    name: 'GeneratedDetailsPopup',
  }
);
